import WireframeNavMenuBase from './WireframeNavMenuBase';
import wireframeNavVertical from '../assets/icons/wireframeNavVertical.svg';

class WireframeNavMenuVertical extends WireframeNavMenuBase {
  constructor(fabricObject) {
    fabricObject.layout = 'column';
    super(fabricObject);
  }

  static iconSvg() {
    return wireframeNavVertical;
  }
}

export default WireframeNavMenuVertical;
